import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api, { formatApiError } from "../api";

/**
 * Activación / Reset de contraseña.
 * Mismo endpoint `/auth/reset-password` cubre:
 *  - activación inicial (admin seedeado sin password conocida)
 *  - reset admin-generado para un alumno
 */
export default function Activate() {
  const { token } = useParams();
  const nav = useNavigate();
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [err, setErr] = useState("");
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (p1.length < 10) {
      setErr("Mínimo 10 caracteres.");
      return;
    }
    if (!/[A-Z]/.test(p1) || !/[a-z]/.test(p1) || !/[0-9]/.test(p1)) {
      setErr("Combiná mayúsculas, minúsculas y números.");
      return;
    }
    if (p1 !== p2) {
      setErr("Las contraseñas no coinciden.");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, newPassword: p1 });
      setOk(true);
      setTimeout(() => nav("/english-id/login"), 1800);
    } catch (ex) {
      setErr(formatApiError(ex));
    } finally {
      setBusy(false);
    }
  };

  if (ok) {
    return (
      <div className="max-w-md mx-auto mt-16 text-center">
        <h1 className="font-serif text-3xl font-bold">¡Listo!</h1>
        <p className="mt-3 text-[13px] text-[#132C44]/70">
          Contraseña establecida. Te llevo al login…
        </p>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto mt-10">
      <h1 className="font-serif text-3xl font-bold">Activá tu cuenta</h1>
      <p className="text-[13px] text-[#132C44]/70 mt-1">
        Elegí una contraseña. Este link es de un solo uso y tiene vencimiento.
      </p>
      <form onSubmit={submit} className="mt-7 space-y-4" data-testid="eid-activate-form">
        <div>
          <label className="text-[12px] font-semibold tracking-widest text-[#132C44]/70 uppercase">
            Nueva contraseña
          </label>
          <input
            type="password"
            required
            value={p1}
            onChange={(e) => setP1(e.target.value)}
            className="mt-1 w-full border border-[#132C44]/25 rounded-xl px-4 py-3 bg-white focus:outline-none focus:ring-2 focus:ring-[#132C44]/30"
            data-testid="eid-activate-p1"
          />
        </div>
        <div>
          <label className="text-[12px] font-semibold tracking-widest text-[#132C44]/70 uppercase">
            Confirmar
          </label>
          <input
            type="password"
            required
            value={p2}
            onChange={(e) => setP2(e.target.value)}
            className="mt-1 w-full border border-[#132C44]/25 rounded-xl px-4 py-3 bg-white focus:outline-none focus:ring-2 focus:ring-[#132C44]/30"
            data-testid="eid-activate-p2"
          />
        </div>
        {err && (
          <div
            className="text-[13px] text-[#9B2C3B] bg-[#9B2C3B]/10 border border-[#9B2C3B]/30 px-3 py-2 rounded-lg"
            data-testid="eid-activate-error"
          >
            {err}
          </div>
        )}
        <button
          disabled={busy}
          type="submit"
          className="w-full mt-2 py-3 rounded-full bg-[#132C44] text-[#F6EFDF] font-semibold text-[13px] hover:bg-[#1E3A5F] disabled:opacity-60"
          data-testid="eid-activate-submit"
        >
          {busy ? "Guardando…" : "Activar cuenta"}
        </button>
      </form>
      <p className="mt-5 text-[11px] text-[#132C44]/60">
        Mínimo 10 caracteres, con mayúsculas, minúsculas y números.
      </p>
    </div>
  );
}
